import omit from "lodash/omit";
import qs from "qs";
import React, { useEffect, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import { Filter } from "~/features/filter";
import { FILTER_BY } from "~/pages/Staff/assets/StaffFilter/lib";

import { DEALER_METRIC_FILTER_KEYS, dealerMetricFilterFields } from "./fields";

// Дефолты старой формы: измерение «по дилеру», текущий дилер
// из sessionStorage, текущая дата.
const getDefaultParams = (): Record<string, string> => {
  const defaults: Record<string, string> = {
    filterBy: FILTER_BY.DEALER,
    period: new Date().toISOString().split("T")[0],
  };
  const currentDealerId = sessionStorage.getItem("currentDealerId");
  if (currentDealerId) {
    defaults.filterItems = currentDealerId;
  }
  return defaults;
};

const FilterMetric = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const fields = useMemo(() => dealerMetricFilterFields(t), [t]);

  // Подставляем дефолты в URL при первом входе, если не заданы явно.
  useEffect(() => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const defaults = getDefaultParams();
    const missing = Object.keys(defaults).filter((key) => !params[key]);
    if (missing.length) {
      history.replace({
        search: qs.stringify({
          ...params,
          ...missing.reduce(
            (acc, key) => ({ ...acc, [key]: defaults[key] }),
            {},
          ),
        }),
      });
    }
  }, []);

  // Сброс возвращает дефолты — так работала старая форма, где при сбросе
  // заново применялись измерение «по дилеру», текущий дилер и текущая дата.
  const handleReset = () => {
    const params = location.search ? qs.parse(location.search.slice(1)) : {};
    const rest = omit(params, [...DEALER_METRIC_FILTER_KEYS, "page"]);
    history.replace({
      search: qs.stringify({ ...rest, ...getDefaultParams() }),
    });
  };

  return (
    <Filter.Root fields={fields} alwaysShow columns={3} onReset={handleReset} />
  );
};

export default FilterMetric;
